import React from "react";

export default class Testimonial extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      testimonial: [
        {
          institute: "Arignar Anna Institute of Science and Technology",
          course: "BE Computer Science",
          desc: "Studied about computers for 4 years and completed degree with 65.8% (First class)",
          year: "2008 to 2012",
        },
        {
          institute: "The Gopalapuram Boys Higher Secondary School",
          course: "HSC",
          desc: "Studied about BIO-MATHS for 2 years and completed my school with 60.5% (First class)",
          year: "2007 to 2008",
        },
        {
          institute: "Thousand lights corporation high school",
          course: "SSLC",
          desc: "Studied about Mathematics, Science, Languages and completed my school with 86% (First class) ",
          year: "2005 to 2006",
        },
      ],
    };
    //this.animateEdu = this.animateEdu.bind(this);
  }

  animateEdu() {
    let elemEdu = document.querySelectorAll("#testimonial .opacity0");
    let topPosEdu = document
      .querySelector("#testimonial .title")
      .getBoundingClientRect().top;
    for (let i = 0; i < elemEdu.length; i++) {
      if (topPosEdu < window.innerHeight / 1.5) {
        if (elemEdu[i].className.indexOf("animate") === -1) {
          elemEdu[i].className += " animate";
        }
      }
    }
  }
  componentDidMount() {
    window.addEventListener("scroll", this.animateEdu);
  }
  render() {
    return (
      <section className="testimonial" id="testimonial">
        <div className="container">
          <div className="title fromBottom opacity0">
            <h2>Testimonial</h2>
            <span>We listen our customers</span>
          </div>
          <div className="testmonial-div row">
            <div className="col-lg-6 col-md-6 col-sm-6 col-xs-12 mcenter  fadeIn opacity0">
              <div className="t-box">
                <p>
                  "Santhanaraj is very responsive and extremely dedicated! Will
                  definitely work with him again."
                </p>
                <h4>
                  - Jim Foley, <span>Synccentric Inc</span>
                </h4>
              </div>
            </div>

            <div className="col-lg-6 col-md-6 col-sm-6 col-xs-12 mcenter  fadeIn opacity0">
              <div className="t-box">
                <p>
                  "Very skilled, great to communicate, and was cooperative to
                  finish the project. Would definitely work together again."
                </p>
                <h4>
                  - Gagan Reddy, <span>Cittamap</span>
                </h4>
              </div>
            </div>

            <div className="col-lg-6 col-md-6 col-sm-6 col-xs-12 mcenter  fadeIn opacity0">
              <div className="t-box">
                <p>
                  "Santhanaraj did an excellent job analyzing my site and fixing
                  all of the errors. I would definitely recommend him to others
                  looking for an IT expert."
                </p>
                <h4>
                  - P M A Raj, <span>Elshadai Enterprises</span>
                </h4>
              </div>
            </div>

            <div className="col-lg-6 col-md-6 col-sm-6 col-xs-12 mcenter  fadeIn opacity0">
              <div className="t-box">
                <p>
                  "Great job and great communication, helping me step by step
                  until everything is perfect."
                </p>
                <h4>- Marketing Geeks</h4>
              </div>
            </div>
          </div>
        </div>
      </section>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/pages/Testimonial.js